import Link from "next/link";
import { FC } from "react";
import { HeaderLink } from "@/app/lib/features/header/header.types";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface TopHeaderItemProps {
  link: HeaderLink;
}

const TopHeaderItem: FC<TopHeaderItemProps> = ({ link }) => {
  return (
    <Link
      href={link.url}
      onClick={() => trackGeneric(`top_link_${link.url.replace(/\//g, "").slice(0, 30)}`, "click")}
      className="text-gray-400 font-medium text-xs hover:underline"
    >
      {link.title}
    </Link>
  );
};

export default TopHeaderItem;
